<template>
  <div v-if="isVisible" class="fixed inset-0 z-50 overflow-auto bg-smoke-light flex items-center justify-center">
    <div class="relative p-8 bg-white w-full max-w-md m-auto flex-col flex rounded-lg">
      <h2 class="text-2xl font-bold mb-6">Edit Talent</h2>
      <form @submit.prevent="submitEditModal">
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">First Name</label>
          <input v-model="localTalent.user.first_name" type="text" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" />
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Last Name</label>
          <input v-model="localTalent.user.last_name" type="text" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" />
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Email</label>
          <input v-model="localTalent.user.email" type="email" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" />
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Skills</label>
          <select v-model="selectedSkill" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
            <option v-for="skill in availableSkills" :key="skill.skill_id" :value="skill.skill_id">{{ skill.skill_name }}</option>
          </select>
        </div>
        <div class="flex justify-end">
          <button type="button" class="mr-4 py-2 px-4 bg-gray-500 text-white rounded" @click="$emit('close')">Cancel</button>
          <button type="submit" class="py-2 px-4 bg-blue-500 text-white rounded">Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import apiClient from '@/axios';

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    selectedTalent: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localTalent: JSON.parse(JSON.stringify(this.selectedTalent)),
      availableSkills: [],
      selectedSkill: ''
    };
  },
  watch: {
    selectedTalent(newVal) {
      this.localTalent = JSON.parse(JSON.stringify(newVal)); // Update local data when prop changes
    },
    isVisible(newVal) {
      if (newVal) {
        this.fetchSkills(); // Fetch skills when modal is visible
      }
    }
  },
  methods: {
    async fetchSkills() {
      try {
        const response = await apiClient.get('/web/skills'); // Fetch available skills
        this.availableSkills = response.data.data;
      } catch (error) {
        console.error('Error fetching skills:', error);
      }
    },
    async submitEditModal() {
      try {
        // Update user information
        await apiClient.put(`/web/users/${this.localTalent.user.user_id}`, {
          email: this.localTalent.user.email,
          first_name: this.localTalent.user.first_name,
          last_name: this.localTalent.user.last_name
        });

        // Add skill to talent
        if (this.selectedSkill) {
          await apiClient.post(`/web/talents/${this.localTalent.user.user_id}/skills/`, {
            skill_id: this.selectedSkill
          });
        }

        this.$emit('save', this.localTalent); // Emit updated talent data
      } catch (error) {
        console.error('Error updating talent:', error);
      } finally {
        this.$emit('close'); // Close the modal after saving
      }
    }
  },
  mounted() {
    this.fetchSkills(); // Fetch skills when the component is mounted
  }
};
</script>

<style scoped>
.smoke-light {
  background-color: rgba(0, 0, 0, 0.5);
}
.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
}
</style>
